import React, { useEffect, useRef, useState, useMemo } from 'react';
import './newcurHeaderInfo.scss';
import { getCookieAmend, setCookie } from '../../util/cookie';
import { generatePaySessionId, getAccountPicture } from '../../util/util';
import Marquee from '../../components/marquee/marquee';
import { useHistory } from 'react-router-dom';
import { useCustomTranslation, getTvdSegment } from '@/hooks/useCustomTranslation';
import { useNextTick } from '../../hooks/nextTick';
import vipImg from '../../assets/img/accoun/vip.png';
import Event, { EVENTS } from '../../util/event';
import { report } from '../../util/dataReporting';

let headerTimeTimer;
let shakeUpDownTimer;
let shakeLeftRightTimer;

export default function HeaderInfor(props) {
  const { t } = useCustomTranslation();
  const jumpHistory = useHistory();
  const nextTick = useNextTick();
  const [isIflix, setIsIflix] = useState(false); // 是WeTV还是Iflix
  const [userInfo, setUserInfo] = useState({
    userNick: '',
    avatar: '',
    isLogin: '',
  }); // 用户信息
  const [userStatus, setUserStatus] = useState(''); // 用户状态，游客、会员、非会员
  const [accountImg, setAccountImg] = useState(''); // 头像右下角图标
  const [shakeUpDown, setShakeUpDown] = useState(false); // 上下抖动
  const [shakeLeftRight, setShakeLeftRight] = useState(false); // 左右抖动
  const [time, setTime] = useState(''); // 头部右上角展示时间
  const [curFocusIdx, setCurFocusIdx] = useState(0); // 当前聚焦的位置，0为登陆或者登录后用户信息位置，1为搜索位置
  const [paySessionId, setPaySessionId] = useState('');
  const curFocusIdxRef = useRef(curFocusIdx); // 当前聚焦的位置，0为登陆或者登录后用户信息位置，1为搜索位置

  const isChecked = useMemo(() => !!(props.headerflag === 1), [props.headerflag]);
  const headerDown = useMemo(() => props.headerDown, [props.headerDown]);
  const isLoginFocus = useMemo(() => (
    !userInfo.isLogin && curFocusIdx === 0 && isChecked
  ), [isChecked, curFocusIdx, userInfo.isLogin]);
  const isSearchFocus = useMemo(() => curFocusIdx === 1 && isChecked, [isChecked, curFocusIdx]);
  const isUserInfoFocus = useMemo(() => (
    userInfo.isLogin && curFocusIdx === 0 && isChecked
  ), [isChecked, curFocusIdx, userInfo.isLogin]);

  const isLoginFocusRef = useRef(isLoginFocus);
  const isSearchFocusRef = useRef(isSearchFocus);
  const isUserInfoFocusRef = useRef(isUserInfoFocus);
  const sourcePage = useRef(props.sourcePage);
  const openVipRef = useRef(null);

  useEffect(() => {
    isLoginFocusRef.current = isLoginFocus;
  }, [isLoginFocus]);

  useEffect(() => {
    isSearchFocusRef.current = isSearchFocus;
  }, [isSearchFocus]);

  useEffect(() => {
    isUserInfoFocusRef.current = isUserInfoFocus;
  }, [isUserInfoFocus]);

  useEffect(() => {
    sourcePage.current = props.sourcePage;
  }, [props.sourcePage]);


  const isCheckedRef = useRef(isChecked);

  // 设置是WeTV还是Iflix
  const setIsIflixStatus = () => {
    if (document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com') {
      setIsIflix(true);
    } else {
      setIsIflix(false);
    }
  };
  // 设置用户信息
  const setUserInfoStatus = () => {
    const isLogin = getCookieAmend('isLogin');
    if (isLogin) {
      setUserInfo({
        userNick: getCookieAmend('user_nick') || 'WeTV',
        avatar: getCookieAmend('avatar'),
        isLogin,
      });
      const currentStatus = getCookieAmend('status');
      if (currentStatus) {
        setUserStatus(currentStatus);
      } else {
        setUserStatus('');
      }
      setAccountImg(getAccountPicture());
    } else {
      setUserInfo(userInfo => ({
        ...userInfo,
        avatar: '',
        isLogin: false,
      }));
    }
  };
  // 时间戳转换成日期时间(时分)
  const getTime = () => {
    const now = new Date();
    let hh = now.getHours(); // 时
    let mm = now.getMinutes(); // 分
    let clock = '';
    if (hh < 10) {
      hh = `0${hh}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    clock = `${hh}:${mm}`;
    setTime(clock);
  };

  // 上下抖动
  const shakeUpDownFuc = () => {
    if (shakeUpDownTimer) {
      clearTimeout(shakeUpDownTimer);
      shakeUpDownTimer = null;
    };
    setShakeUpDown(true);
    shakeUpDownTimer = setTimeout(() => {
      setShakeUpDown(false);
      clearTimeout(shakeUpDownTimer);
      shakeUpDownTimer = null;
    }, 2000);
  };
  // 左右抖动
  const shakeLeftRightFuc = () => {
    if (shakeLeftRightTimer) {
      clearTimeout(shakeLeftRightTimer);
      shakeLeftRightTimer = null;
    };
    setShakeLeftRight(true);
    shakeLeftRightTimer = setTimeout(() => {
      setShakeLeftRight(false);
      clearTimeout(shakeLeftRightTimer);
      shakeLeftRightTimer = null;
    }, 2000);
  };

  const removeShakeFunc = () => {
    if (shakeLeftRightTimer) {
      setShakeLeftRight(false);
      clearTimeout(shakeLeftRightTimer);
      shakeLeftRightTimer = null;
    };
    if (shakeUpDownTimer) {
      setShakeUpDown(false);
      clearTimeout(shakeUpDownTimer);
      shakeUpDownTimer = null;
    };
  };

  // 五个交互函数开始
  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current === 1) {
      removeShakeFunc();
      setCurFocusIdx(curFocusIdxRef.current - 1);
    } else {
      shakeLeftRightFuc();
    }
  };

  const moveRight = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current === 0) {
      removeShakeFunc();
      setCurFocusIdx(curFocusIdxRef.current + 1);
    } else {
      shakeLeftRightFuc();
    }
  };

  const moveUp = () => {
    if (!isCheckedRef.current) return;
    shakeUpDownFuc();
  };

  const moveDown = () => {
    if (!isCheckedRef.current) return;
    headerDown();
  };

  const moveClick = () => {
    if (!isCheckedRef.current) return;
    if (isLoginFocusRef.current) {
      // 登录按钮聚焦
      setCookie('loginSourcePage', sourcePage.current);
      // 登录上报
      report({
        attaId: '0e600058578',
        scene: 'linuxtv_homepage',
        module: 'header',
        button: 'login',
      });
      setTimeout(() => {
        jumpHistory.push('/login');
      }, 500);
    } else if (isUserInfoFocusRef.current) {
      const paySessionId = generatePaySessionId();
      setPaySessionId(paySessionId);
      nextTick(() => {
        openVipRef.current?.click?.();
        // 登录后用户信息聚焦
        setCookie('vipSourcePage', sourcePage.current);
        // 开通页上报
        report({
          attaId: '0e600058578',
          scene: 'linuxtv_homepage',
          module: 'header',
          button: 'open_vip',
        });
        // setTimeout(() => {
        jumpHistory.push('/orderVip/2034');
        // }, 500);
      });
    } else if (isSearchFocusRef.current) {
      // 搜索按钮聚焦
      report({
        attaId: '0e600058578',
        scene: 'linuxtv_homepage',
        module: 'header',
        button: 'search_bar',
      });
      jumpHistory.push(`/search/${sourcePage.current}`);
    }
  };
  // 五个交互函数结束

  // 组件初始化，设置用户信息以及应用信息以及添加定时器计算右上角时间
  useEffect(() => {
    setShakeUpDown(false);
    setShakeLeftRight(false);
    setCurFocusIdx(0);

    Event.on(EVENTS.HEADER_INFO_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HEADER_INFO_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HEADER_INFO_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HEADER_INFO_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HEADER_INFO_KEY_DOWN_CLICK, moveClick);
    // iflix还是WeTV，右上角展示不同LOGO
    setIsIflixStatus();
    // 设置用户信息
    setUserInfoStatus();
    // 头部右侧时间更新
    if (headerTimeTimer) {
      clearInterval(headerTimeTimer);
      headerTimeTimer = null;
    }
    headerTimeTimer = setInterval(() => {
      getTime();
    }, 1000);
    return () => {
      clearInterval(headerTimeTimer);
      Event.off(EVENTS.HEADER_INFO_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HEADER_INFO_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HEADER_INFO_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HEADER_INFO_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HEADER_INFO_KEY_DOWN_CLICK, moveClick);
    };
  }, []);

  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  function mouseClick(e, idx) {
    e && e.stopPropagation && e.stopPropagation();
    if (isCheckedRef.current && curFocusIdxRef.current === idx) {
      moveClick();
      return;
    }
    setCurFocusIdx(idx);
    curFocusIdxRef.current = idx;
    if (sourcePage.current.includes('particular')) {
      Event.emit(EVENTS.PARTICULAR_UPDATE_STATE, { headerflag: 1 });
    } else if (sourcePage.current.includes('home')) {
      Event.emit(EVENTS.HOME_UPDATE_STATE, { headerflag: 1 });
    }
  }

  return (
    <div className="content_left">
      <div className="but_left">
        {userInfo.isLogin ? (
          <div
            ref={openVipRef}
            className={[
              isUserInfoFocus ? 'logbut_div_h' : 'logbut_div_s',
              shakeUpDown && curFocusIdx === 0 ? 'headShake' : null,
              shakeLeftRight && curFocusIdx === 0 ? 'headShake1' : null,
            ].join(' ')}
            dt-eid="icon"
            dt-params={`mod_id=navbar&icon_type_tv=status_bar&icon_name=open_vip&isLogin=${userInfo.isLogin ? '1' : '0'}&userStatus=${userStatus}&pay_scene=VIP&pay_session_id=${paySessionId}`}
          >
            <span
              onClick={e => mouseClick(e, 0)}
              style={{
                paddingLeft:
                  userStatus === '3'
                    ? `${130 / global.constants.rootValue}rem`
                    : `${70 / global.constants.rootValue}rem`,
                // eslint-disable-next-line
                color: curFocusIdx === 0 ? '#fff' : userStatus === '3'
                  ? '#efdb2b'
                  : '#cfcfcf',
              }}
              className={[
                // eslint-disable-next-line
                isUserInfoFocus ? props.isVip === 'VIP' ? 'logged_but_v' : 'logged_but_h' : 'logged_but_s'].join(' ')}>
              {userStatus === '3' ? (
                <Marquee
                  children={`${t('尊敬的VIP')} ${userInfo.userNick}， ${isIflix ? t('欢迎使用iflix') : t('欢迎使用WeTV')}`}
                  mainWidth={330}
                  scrollStatus={isUserInfoFocus}
                  index={0}
                />
              ) : (
                <Marquee
                  children={t('加入VIP享受会员特权')}
                  mainWidth={390}
                  scrollStatus={isUserInfoFocus}
                  index={0}
                />
              )}
            </span>
            {userStatus === '3' ? (
              <img className={'logged_vip'} src={vipImg} alt="" />
            ) : null}
            {userInfo.avatar !== '' ? (
              <img className={'logged_avatar'} src={userInfo.avatar} alt="" />
            ) : null}
            {accountImg !== '' ? (
              <img className={'logged_account'} src={accountImg.default} alt="" />
            ) : null}
          </div>
        ) : (
          <div className="loginLink">
            <span
              onClick={e => mouseClick(e, 0)}
              className={[
                // eslint-disable-next-line
                isLoginFocus ? props.isVip === 'VIP'
                  ? 'log_but_v' : 'log_but_h' : 'log_but_s',
                shakeUpDown && curFocusIdx === 0 ? 'headShake' : null,
                shakeLeftRight && curFocusIdx === 0 ? 'headShake1' : null,
              ].join(' ')}
              dt-eid="icon"
              dt-params={`mod_id=navbar&icon_name=login&isLogin=${userInfo.isLogin ? '1' : '0'}`}
            >
              <Marquee
                children={t('登录')}
                mainWidth={80}
                scrollStatus={isLoginFocus}
                index={0}
              />
            </span>
          </div>
        )}

        <div className='searchLink'>
          <span
            onClick={e => mouseClick(e, 1)}
            className={[
              // eslint-disable-next-line
              isSearchFocus ? props.isVip === 'VIP'
                ? 'search_but_v' : 'search_but_h' : 'search_but_s',
              shakeUpDown && curFocusIdx === 1 ? 'headShake' : null,
              shakeLeftRight && curFocusIdx === 1 ? 'headShake1' : null,
            ].join(' ')}
          >
            {t('搜索')}
          </span>
        </div>
      </div>
      <div className="but_right">
        <div className="time">{time}</div>
        <div className={`logo ${isIflix ? 'logo_iflix' : ''} ${getTvdSegment() === 'tvdtv' ? 'logo_tvdtv' : ''}`}></div>
      </div>
    </div>
  );
};
